import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchInvitedCandidates,
  setInvitedCandidatesLoading,
  showFilterModal,
  updateFilters,
  updatePagination,
} from "@/reducers/client_candidates/candidatesinvited";
import { getIsFilterApplied } from "@/utilities/utils";

import TableSearch from "../../../dataTables/TableSearch";
import FilterButton from "../../../ListingFilters/FilterButton";

/**
 * A function for handling search and filters in the UI.
 *
 * @param {Event} e - The event object
 * @return {JSX.Element} The rendered UI component
 */
export const SearchFilter = () => {
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesInvited,
  );
  const filterApplied = getIsFilterApplied(filters);
  const dispatch = useDispatch();
  /**
   * A function that handles the search event.
   *
   * @param {Event} e - the event triggering the search
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setInvitedCandidatesLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(fetchInvitedCandidates(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="SearchFilter_Wrapper tour-invited-search">
      <div className="flex gap-[15px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        <FilterButton
          filterApplied={filterApplied}
          handleClick={() => {
            dispatch(showFilterModal(true));
          }}
        />
      </div>
    </div>
  );
};
